import React from 'react'

function Home() {
    return (
        <div>
            <div className="w-1/4">hello</div>
            <div className="w-3/4">bye</div>
        </div>
    )
}

export default Home
